import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { setupTelegram, inTelegram } from './platform/telegram.ts';
import { captureSource } from './platform/source.ts';
import { track } from './platform/track.ts';
import { API_URL } from './platform/config.ts';
import './styles.css';

setupTelegram();
const visit = captureSource();
if (visit) track('visit', { kind: visit.kind, source: visit.source ?? '', campaign: visit.campaign ?? '', landing: visit.landing ?? '' });

// ошибки клиента — на сервер (не чаще 30 в час, решает сервер)
const report = (message: string, stack = '') => {
  fetch(API_URL, { method: 'POST', headers: { 'content-type': 'application/json' }, keepalive: true,
    body: JSON.stringify({ action: 'client_error_anon', message, stack, url: location.pathname }) }).catch(() => {});
};
addEventListener('error', e => report(String(e.message), String(e.error?.stack ?? '')));
addEventListener('unhandledrejection', e => report(String(e.reason?.message ?? e.reason), String(e.reason?.stack ?? '')));

// PWA: только на сайте (в Telegram service worker не нужен)
if ('serviceWorker' in navigator && !inTelegram() && import.meta.env.PROD) {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
